module.exports = __webpack_public_path__ + "static/media/pharmacy.b8759239.png";